import { NavLink } from 'react-router-dom'
import dataPoints from 'svg/data-points.svg'
import './HeroSection.scss'

export const HeroSection = () => {
    return (
        <section className="hero">
            <div className="hero__intro">
                <div className="hero__greeting">
                    <p className="hero__hi">Hello world!, I'm </p>
                    <p className="hero__me">
                        <span className="hero__name">ALEJANDRO</span>
                        <span className="hero__lastname">COCA</span>
                    </p>
                    <p className="hero__role">Software Engineer</p>
                </div>
                <div className="hero__links">
                    <NavLink to="projects"
                        className="hero__link hero__link--cta">PROJECTS</NavLink>
                    <NavLink to="ui-components"
                        className="hero__link hero__link--button">UI COMPONENTS</NavLink>
                </div>
            </div>
            <img
                src={dataPoints}
                alt="Data points"
                className="hero__image"
            />
        </section>
    )
}